<template>
  <v-container>
    <h1>Leveringsmetoder for {{ vendor.name }}</h1>

    <AdminBreadcrumbs :vendor="vendor" tail-text="Betalingsmetoder" />

    <v-card class="orange lighten-5" elevation="3">
      <v-form ref="form" lazy-validation @submit.prevent="submit">
        <v-card-title class="white--text orange">
          Rediger leveringsmetoder
        </v-card-title>

        <v-container>
          <v-checkbox
            v-for="delivery_method in organization_delivery_methods"
            :key="delivery_method.id"
            v-model="vendor.delivery_methods"
            :label="delivery_method.name"
            :value="delivery_method.id"
            class="mt-0"
          />
        </v-container>

        <v-card-actions>
          <v-btn type="submit" color="success">
            <v-icon left> mdi-content-save </v-icon>
            Lagre innstillinger
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import backend from "@/backend";
import AdminBreadcrumbs from "@/components/AdminBreadcrumbs";

export default {
  name: "AdminVendorShipping",

  components: {
    AdminBreadcrumbs,
  },

  props: {
    vendorId: {
      type: String,
      required: true,
      default: "",
    },
  },

  data: function () {
    return {
      vendor: {},
      organization_delivery_methods: [],
      isSaving: false,
      rules: {
        required: (v) => !!v || "Required",
      },
    };
  },

  async created() {
    this.vendor = await backend.get(`vendors/${this.vendorId}/`);
    this.organization_delivery_methods = await backend.get("deliverymethods/", {
      organization: this.vendor.organization,
    });
  },

  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.isSaving = true;
        this.vendor = await backend.put(
          `vendors/${this.vendor.id}/`,
          {
            name: this.vendor.name,
            organization: this.vendor.organization,
            delivery_methods: this.vendor.delivery_methods,
          },
          {
            vendor: this.vendorId,
          }
        );

        this.$router.push({
          name: "adminVendorDetail",
          params: {
            vendorId: this.vendor.id.toString(),
          },
        });

        this.$store.dispatch("add", {
          type: "success",
          message: "Leveringsmetoder er nå lagret.",
        });

        this.isSaving = false;
      }
    },
  },
};
</script>
